import Skeleton from "@mui/material/Skeleton";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

export type TableSkeletonProps = {
  rows?: number;
  columns: number;
};

export function TableSkeleton({ rows = 6, columns }: TableSkeletonProps) {
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <TableRow key={rowIndex}>
          {Array.from({ length: columns }).map((__, colIndex) => (
            <TableCell key={colIndex} sx={{ py: 1.35, px: 1.25 }}>
              <Skeleton
                variant="rounded"
                height={14}
                width={colIndex === 0 ? "40%" : `${55 + ((rowIndex + colIndex) % 4) * 10}%`}
                sx={{ borderRadius: "4px" }}
              />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}

export default TableSkeleton;
